export const formatDate = (date) => {
  if (!date || !(date instanceof Date)) return '';
  return date.toLocaleString('en-US', { month: 'short', day: 'numeric', year: 'numeric', hour: 'numeric', minute: '2-digit', hour12: true });
};

export const encodeEmail = (email) => email.replace(/\./g, '_');
